import { Unit } from "./enums";

export const unitsOptions = [
    { label: "Department", value: Unit.Department },
    { label: "Faculty", value: Unit.Faculty },
    { label: "SBC", value: Unit.Sbc },
    { label: "Secretariat", value: Unit.Secretariat },
    { label: "Senate", value: Unit.Senate },
];
